import auth from "../../../auth/auth-helper";


const AllLoanList = async (signal,credentials) => {
  
    try {
      let response = await fetch(
        process.env["REACT_APP_API_HOST"] + "/api/" + auth.getuserType() + "/loans",
        {
          method: "GET",
          signal: signal,
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'x-access-token':credentials
        },
        }
      );
      return await response.json();
    } catch (err) {
      console.log(err);
    }
  };

  export {  AllLoanList };